import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8r5hpus238: FaireBrandEntity = {
  token: "b_8r5hpus238",
  type: "brand",
  name: "GRIFFON 1924",
  avatarUrl:
    "https://cdn.faire.com/fastly/d9c65bfb5dfafa29cb3934e42ae22d1f470a82b6e908b51a9f5960544b80151e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b8ff5ab002e90dccdf112dff31db23c9c5419329d55d37093b46b4419959b538.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d9c65bfb5dfafa29cb3934e42ae22d1f470a82b6e908b51a9f5960544b80151e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b8ff5ab002e90dccdf112dff31db23c9c5419329d55d37093b46b4419959b538.jpeg",
  location: "FRA",
  minimumOrderDollars: 104,
  rating: 4.3,
  reviewCount: 3,
  isInsider: false,
  description:
    'Local Expertise and Production  \nGriffon 1924 has been perpetuating a French textile heritage since 1924, producing knitwear in its own workshop in Roanne that combines traditional techniques and modern innovations. The brand is committed to responsible and local manufacturing, ensuring quality, durability, and timeless elegance.\n\nA Premium and Responsible Collection  \nOur "Essentials" collection embodies the excellence of Made in France, with knitwear designed to last. Sweaters, cardigans, and accessories are crafted with attention to detail and a rigorous selection of materials.\n\nNatural and Certified Materials  \nOur creations are made with high-end fibers, respectful of the environment and animal welfare:  \n• 75% superfine merino wool & 25% baby suri alpaca – unmatched softness and warmth.  \n• 90% wool and 10% cashmere – finesse and elegance.\n\nYarn Quality: A Guarantee of Excellence  \nWe select yarns from the best European spinning mills. For our wool and alpaca products, we work with LANECARDATE, a company recognized for its ecological and ethical commitment:  \n• Mulesing-free, RWS & SustainaWool Green V8 – respect for animal welfare.  \n• OEKO-TEX & WOOLMARK certifications – guarantee of durable and high-quality wool.\n\nInclusive and Elegant Fashion  \nDesigned for modern women, the collection ranges from sizes 38 to 52, in several timeless and trendy colors.',
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:47.472Z",
    importedBy: "entity-db-cli",
  },
};
